import type { AssetRecord } from "../graph/buildAssetDocsGraph";
import type { AssetProfile } from "./assetProfiles";

interface AssetHit {
    _source?: Record<string, unknown>;
}

const asText = (value: unknown): string =>
    typeof value === "string" || typeof value === "number" ? String(value) : "";

const asCount = (value: unknown): number => (typeof value === "number" ? value : 0);

export const toAssetRecords = ({
    body,
    profile,
}: {
    body: unknown;
    profile: AssetProfile;
}): AssetRecord[] => {
    const hits = (body as { hits?: { hits?: AssetHit[] } })?.hits?.hits ?? [];
    return hits.flatMap((hit) => {
        const source = hit._source ?? {};
        const id = asText(source[profile.keyField]);
        if (!id) return [];
        const label = profile.labelFields.map((field) => asText(source[field])).find(Boolean) ?? id;
        const homeUrl = profile.homeField ? asText(source[profile.homeField]) : "";
        const customer = asText(source[profile.customerField]);
        return [
            {
                id,
                label,
                ...(homeUrl.startsWith("http") ? { homeUrl } : {}),
                ...(customer ? { customer } : {}),
                counts: Object.fromEntries(
                    profile.reportTypes.map((report) => [
                        report.countField,
                        asCount(source[report.countField]),
                    ]),
                ),
            },
        ];
    });
};
